export default "__VITE_ASSET__DzT6Nud5__"